import { render, staticRenderFns } from "./Civil.vue?vue&type=template&id=6e278840&scoped=true"
import script from "./Civil.vue?vue&type=script&lang=js"
export * from "./Civil.vue?vue&type=script&lang=js"
import style0 from "./Civil.vue?vue&type=style&index=0&id=6e278840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e278840",
  null
  
)

export default component.exports